import React from 'react'

import Intro from '../components/trias/Intro'
import Selections from '../components/trias/Selections'
import GuideBox from '../components/trias/GuideBox';
import Mainbg from '../components/common/styled/Mainbg';


export default function Trias() {
  return (
    <>
      <Intro></Intro>
      <Mainbg>
        <Selections></Selections>
        <GuideBox></GuideBox>
      </Mainbg>
    </>
  )
}
